import { SVGProps } from 'react';

interface DollarToggleIconType extends SVGProps<SVGAElement> {
  stopColorOne?: string;
  stopColorTwo?: string;
}

const DollarToggleIcon = ({
  width = 24,
  height = 24,
  stopColorOne = '#F9A606',
  stopColorTwo = '#FBCC5F',
}: DollarToggleIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    data-palette="DollarToggleIcon">
    <circle cx="8" cy="8" r="8" fill="url(#paint0_linear_3557_24108)" />
    <path
      d="M5.37866 9.50218H9.50368C9.71075 9.50218 9.87868 9.33433 9.87868 9.12718C9.87868 8.9201 9.71075 8.75218 9.50368 8.75218H6.50368C5.46813 8.75218 4.62866 7.9127 4.62866 6.87718C4.62866 5.84167 5.46813 5.0022 6.50368 5.0022H7.25368V3.5022H8.75368V5.0022H10.6287V6.50218H6.50368C6.29656 6.50218 6.12866 6.6701 6.12866 6.87718C6.12866 7.08433 6.29656 7.25218 6.50368 7.25218H9.50368C10.5392 7.25218 11.3787 8.09165 11.3787 9.12718C11.3787 10.1627 10.5392 11.0022 9.50368 11.0022H8.75368V12.5022H7.25368V11.0022H5.37866V9.50218Z"
      fill="#262832"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3557_24108"
        x1="4"
        y1="14.5"
        x2="14.5"
        y2="3.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={stopColorOne} />
        <stop offset="1" stopColor={stopColorTwo} />
      </linearGradient>
    </defs>
  </svg>
);

export default DollarToggleIcon;
